export const numberWithSpaces = (number, isNeedTransform = true) => {
    let float = number

    if (isNeedTransform) {
        float = parseFloat(parseFloat(number).toFixed(2))
    }

    return float.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
